import { Injectable, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { HttpRequestService } from "../../../../shared/services/http-request/http-request.service";
import { IBeneficiaryDetails } from "../../admin-modules/beneficiary/models/beneficiary.model";
import { API } from "../../../../shared/constants/api-url";
import { PatchPatientDetails } from "../../../../shared/store/patient/patient.action";

@Injectable({
  providedIn: 'root'
})
export class PatientService {
  private store = inject(Store);
  private httpRequestService = inject(HttpRequestService);

  private patientSubject = new BehaviorSubject<IBeneficiaryDetails>(null);
  patientSubject$ = this.patientSubject.asObservable();

  getPatientDetailsById(id: string): Observable<unknown> {
    return this.httpRequestService.get(`${API.BENEFICIARY.BENEFICIARY}/${id}`);
  }

  setStorePatient(id: string) {
    this.getPatientDetailsById(id)
      .pipe(tap((resp: IBeneficiaryDetails) => resp && this.updateStore(resp as IBeneficiaryDetails)))
      .subscribe();
  }

  clearStore() {
    this.updateStore(null);
  }

  private updateStore(beneficiary: IBeneficiaryDetails | null) {
    this.patientSubject.next(beneficiary);
    this.store.dispatch(new PatchPatientDetails(beneficiary));
  }
}